import { useEffect, useState } from "react";

import sessionDB from "../../../utils/sessionDB";

const API_URL = "https://us1.locationiq.com/v1/reverse.php";

export function useLocalityDisplay(latitude, longitude) {
  const [locality, setLocality] = useState("");
  const [attempt, setAttempt] = useState(0);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (latitude === null || longitude === null) {
      setStatus("idle");
      setLocality("");
      setError(null);
      return;
    }
    let cancelled = false;
    setStatus("loading");
    setError(null);

    const token =
      sessionDB.getSession()?.commonobj?.Location_Access_Token?.[0];

    if (!token) {
      setLocality("");
      setStatus("error");
      setError("Location access is not configured. Please contact your administrator.");
      return;
    }

    fetch(
      `${API_URL}?key=${token}&lat=${latitude}&lon=${longitude}&format=json`
    )
    .then((res) => {
            if (!res.ok) throw new Error("LocationIQ request failed");
            return res.json(); })

      .then((data) => {
        if (cancelled) return;
        if (data?.display_name) {
          const firstThree = data.display_name
            .split(",")
            .map((part) => part.trim())
            .slice(0, 3)
            .join(", ");

          const cityState = [
            data.address?.city || data.address?.town || data.address?.village,
            data.address?.state,
          ]
            .filter(Boolean)
            .join(", ");

          setLocality(`${firstThree}, ${cityState}`);
          setStatus("success");
        }
         else {
          setLocality("");
          setStatus("error");
          setError("Location cannot be fetched");
        }
      })
     .catch((err) => {
       if (!cancelled) {
         setLocality("");
         setStatus("error");
         setError(
           err?.message ||
           err?.data?.message ||
           "Location cannot be fetched"
         );
       }
     });

    return () => { cancelled = true; };
  }, [latitude, longitude, attempt]);

  return { locality, status, error, isLoading: status === "loading", refetch: () => setAttempt(value => value + 1) };
}